/* Adaptr Orbit — Web Control Room nav model (3 groups, 11 pages). */

export type NavItem = { id: string; label: string; icon: string; count?: number; badge?: string };
export type NavGroup = { group: string; items: NavItem[] };

export const NAV: NavGroup[] = [
  {
    group: "Learn",
    items: [
      { id: "dashboard", label: "Dashboard", icon: "layout-dashboard" },
      { id: "curriculum", label: "Curriculum", icon: "route" },
      { id: "achievements", label: "Achievements", icon: "award" },
    ],
  },
  {
    group: "Work context",
    items: [
      { id: "profile", label: "Profile & memory", icon: "id-card" },
      { id: "history", label: "History", icon: "history" },
    ],
  },
  {
    group: "Account",
    items: [
      { id: "billing", label: "Billing & usage", icon: "credit-card" },
      { id: "settings", label: "Settings", icon: "settings" },
      { id: "team", label: "Team / Org", icon: "users", badge: "PLAN" },
      { id: "help", label: "Help & support", icon: "life-buoy" },
    ],
  },
];

export const CRUMB: Record<string, [string, string]> = {
  dashboard: ["Learn", "Dashboard"],
  curriculum: ["Learn", "Curriculum"],
  achievements: ["Learn", "Achievements"],
  profile: ["Work context", "Profile & memory"],
  history: ["Work context", "History"],
  billing: ["Account", "Billing & usage"],
  settings: ["Account", "Settings"],
  team: ["Account", "Team / Org"],
  help: ["Account", "Help & support"],
};

export type TopAction = { icon: string; label: string; variant: "ghost" | "live" | "dark" | "danger" };
export const TOP_ACTION: Record<string, TopAction> = {
  billing: { icon: "zap", label: "Buy credits", variant: "live" },
  team: { icon: "user-plus", label: "Invite", variant: "live" },
};
